module.exports = __webpack_public_path__ + "media/speech-bubbles/small-speech-bubble-136ad08e.svg";